import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";
import { AgenteFinanceiroResolver } from "src/app/shared/resolvers/agente-financeiro.resolver";
import { FaixaCarteiraPessoaJuridicaCadastroComponent } from "./cadastro/faixa-carteira-pessoa-juridica-cadastro.component";
import { FaixaCarteiraPessoaJuridicaPesquisaComponent } from "./pesquisa/faixa-carteira-pessoa-juridica-pesquisa.component";



const routes: Routes = [
  {
    path: 'faixa-carteira-pessoa-juridica/pesquisa',
    component: FaixaCarteiraPessoaJuridicaPesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      agentes: AgenteFinanceiroResolver,
    },
    data: { canReuse: false },
  },
  {
    path: 'faixa-carteira-pessoa-juridica/cadastro',
    component: FaixaCarteiraPessoaJuridicaCadastroComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      agentes: AgenteFinanceiroResolver,
    },
    data: { canReuse: false },
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class FaixaCarteiraPessoaJuricaRoutingModule { }
